import { render, staticRenderFns } from "./whatapp-chat-ordre.vue?vue&type=template&id=9e271d38&scoped=true&"
import script from "./whatapp-chat-ordre.vue?vue&type=script&lang=js&"
export * from "./whatapp-chat-ordre.vue?vue&type=script&lang=js&"
import style0 from "./whatapp-chat-ordre.vue?vue&type=style&index=0&id=9e271d38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e271d38",
  null
  
)

export default component.exports